import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { img } from "../lib/api";

export default function JournalArticle() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); api.get(`/journal/${slug}`).then(r => setA(r.data)).catch(() => {}); }, [slug]);
  if (!a) return <div className="max-w-2xl mx-auto px-5 py-20 space-y-4"><div className="h-8 w-2/3 shimmer" /><div className="h-64 w-full shimmer" /></div>;
  return (
    <article>
      <div className="relative h-[55vh] min-h-[360px] flex items-end overflow-hidden">
        <img src={img(a.cover)} alt={a.title} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/40" />
        <div className="relative max-w-3xl mx-auto px-5 lg:px-10 pb-14 text-ivory w-full">
          <span className="eyebrow text-ivory/80">{a.category}</span>
          <h1 className="serif text-4xl lg:text-6xl mt-3">{a.title}</h1>
          <p className="text-ivory/70 text-sm mt-3">By {a.author}</p>
        </div>
      </div>
      <div className="max-w-2xl mx-auto px-5 lg:px-10 py-16">
        {(a.body || "").split("\n\n").map((para, i) => <p key={i} className="text-forest/75 leading-[1.9] text-lg mb-6">{para}</p>)}
        <Link to="/journal" className="btn-outline mt-6">Back to Journal</Link>
      </div>
    </article>
  );
}
